import React, { useEffect } from "react";
import "./Explore_By_Category.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Common_Heading_Holder from "../../common-components/common_heading_holder/Common_Heading_Holder";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import { getGroupByProduct } from "../../../features/products/productsSlice";
import { variant_type } from "../../../utils/common";

const Explore_By_Category = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup
  );


  useEffect(() => {
    dispatch(getGroupByProduct());
  }, [dispatch]);

  return (
    <section className="Explore_By_Category">
      <Common_Heading_Holder headingText={"Explore by Products"} />

      <div className="white_card_div">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 design_1 category_swiper_holder pe-0">

            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, catIndex) => (
                <div key={catIndex} className="mb-4">

                  {/* ✅ Category Heading */}
                  <div className="category_heading_holder">
                    <h5 className="category_heading_text">
                      {category?.name}
                    </h5>
                  </div>

                  {/* ✅ Product Slider */}
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={10}
                    slidesPerView={2}
                    breakpoints={{
                      485: { slidesPerView: 2 },
                      768: { slidesPerView: 3 },
                      992: { slidesPerView: 3 },
                      1200: { slidesPerView: 4 },
                    }}
                    className="categary_grid_slider"
                  >
                    {category?.Products?.map((product, index) => {
                      let metal, size, triple;

                      if (
                        Number(product?.variant_type_id) ===
                        Number(variant_type.Single)
                      ) {
                        metal = product?.Product_Variants?.[0];
                      } else if (
                        Number(product?.variant_type_id) ===
                        Number(variant_type.Double)
                      ) {
                        metal = product?.Product_Variants?.[0];
                        size = metal?.Double_Variants?.[0];
                      } else if (
                        Number(product?.variant_type_id) ===
                        Number(variant_type.Triple)
                      ) {
                        metal = product?.Product_Variants?.[0];
                        size = metal?.Double_Variants?.[0];
                        triple = size?.Triple_Variants?.[0];
                      }

                      const activeVariant = triple || size || metal;

                      return (
                        <SwiperSlide key={index}>
                          <div className="grid_view">
                            <Product_Info_Card
                              product={product}
                              id={product?.id}
                              imgSrc={
                                process.env.REACT_APP_IMG_URL + product?.image
                              }
                              vdoSrc={
                                process.env.REACT_APP_IMG_URL + product?.video
                              }
                              productName={product?.name}
                              mrp={activeVariant?.mrp || 0}
                              priceText={activeVariant?.price || 0}
                              kgText={activeVariant?.name}
                              savingPrice={
                                parseFloat(activeVariant?.mrp || 0) -
                                parseFloat(activeVariant?.price || 0)
                              }
                              showQty
                            />
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>

                  <div
                    className="gray_div"
                    onClick={() => {
                      navigate("/shop");
                    }}
                  >
                    <div className="view_more_div">
                      <p className="text">View More</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-danger">No products available.</p>
            )}
          </div>

          {/* ✅ View More Button */}

          {/* <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-1 col-sm-12 ps-0">
            <div
              className="gray_div"
              onClick={() => {
                navigate("/shop");
              }}
            >
              <div className="view_more_div">
                <p className="text">View More</p>
              </div>
            </div>
          </div> */}


        </div>
      </div>
    </section>
  );
};

export default Explore_By_Category;